
const AccountAPI = {
  account: {
    list: '/accounts',
    detail: '/accounts/:id',
    update: '/accounts/:id',
    update_plan: '/accounts/:id',
  },
  kyc: {
    list: '/kycs',
    detail: '/kycs/:id',
    approve: '/kycs/:id/approve',
    reject: '/kycs/:id/reject',
    update: '/kycs/:id',
  },
  bo: {
    list: '/back_offices',
    detail: '/back_offices/:id',
    create: '/back_offices',
    update: '/back_offices/:id',
    bulk_delete: '/back_offices/bulk-delete',
  },
  referral: {
    list: '/referral',
  }
}
export default AccountAPI
